module.exports = __webpack_public_path__ + "static/moskize91-4946e0774ab8f4e2c01c0c6364abff70.png";